export const getTenFlags = (array) => {
  let new_array = [];
  let size = array.length;
  while (new_array.length < size) {
    let rand = Math.floor(Math.random() * size);
    let current_value = array[rand];
    let found_value = new_array.filter(
      (val) => val.name === current_value.name
    );
    if (found_value.length === 0) {
      new_array.push(current_value);
    }
  }

  return new_array;
};

export const countriesStyles = [
  {
    outer_size: "box-size-55",
    inner_size: "box-size-40",
    style: { top: "70%", left: "10px" },
  },
  {
    outer_size: "box-size-55",
    inner_size: "box-size-40",
    style: { top: "29%", left: "2px" },
  },
  {
    outer_size: "box-size-55",
    inner_size: "box-size-40",
    style: { top: "2px", left: "20%" },
  },
  {
    outer_size: "box-size-45",
    inner_size: "box-size-35",
    style: { top: "40px", left: "52%" },
  },
  {
    outer_size: "box-size-45",
    inner_size: "box-size-35",
    style: { top: "2px", left: "70%" },
  },
  {
    outer_size: "box-size-60",
    inner_size: "box-size-45",
    style: { top: "80px", left: "29%" },
  },
  {
    outer_size: "box-size-60",
    inner_size: "box-size-45",
    style: { top: "70px", left: "70%" },
  },
  {
    outer_size: "box-size-45",
    inner_size: "box-size-35",
    style: { top: "60%", left: "30%" },
  },
  {
    outer_size: "box-size-60",
    inner_size: "box-size-45",
    style: { top: "70%", left: "66%" },
  },
  {
    outer_size: "box-size-60",
    inner_size: "box-size-45",
    style: { top: "45%", left: "51%" },
  },
];

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
